import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { ReportsComponent } from './reports.component';
import { AccessType } from '@app/@shared/enums/access-types.enum';
import { AccessGuard } from '@app/@shared/guards/access.guard';
import { ExistingReportComponent } from '@app/areas/reports/components';
import { ExistingBatchReportDetailComponent } from './components/existing-batch-report-detail/existing-batch-report-detail.component';
import { ExistingSdkBatchReportDetailComponent } from './components/existing-sdk-batch-report-detail/existing-sdk-batch-report-detail.component';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: ':locationId/reports',
      component: ReportsComponent,
      canActivate: [AccessGuard],
      data: { title: 'Reports', requiredAccessTypes: [AccessType.ReportAdmin] },
    },
    {
      path: ':locationId/reports/:reportId',
      component: ExistingReportComponent,
      canActivate: [AccessGuard],
      data: { title: 'Reports', requiredAccessTypes: [AccessType.ReportAdmin] },
    },
    {
      path: ':locationId/batch-detail/:batchId',
      component: ExistingBatchReportDetailComponent,
      data: { title: 'Batch', requiredAccessTypes: [AccessType.ReportAdmin] },
      canActivate: [AccessGuard],
    },
    {
      path: ':locationId/sdk-batch-detail/:batchId',
      component: ExistingSdkBatchReportDetailComponent,
      data: { title: 'Batch', requiredAccessTypes: [AccessType.ReportAdmin] },
      canActivate: [AccessGuard],
    },
  ]),
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportsRoutingModule {}
